import React, { memo, useMemo } from 'react'

import { Icon, MoreChorizontal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import Dropdown from 'Pods/ThreeDStudio/Shared/Dropdown/Dropdown'

import Menu from './Components/Menu/Menu'

// Same layer as the detached History window (_detached_window.scss): the menu is
// portalled when opened, after the window, so it paints over it while staying under
// the site navbar (453).
const PORTAL_Z_INDEX = 452
const triggerIconSize = { height: '36px', width: '36px' }
const triggerIcon = <Icon notSpaced svgComponent={MoreChorizontal} color="dark" size={triggerIconSize} />

function VariationMenu({
  className,
  createdAt = undefined,
  isDisabled = false,
  shouldClose,
  setShouldClose,
  onOpenChange,
  onSetAsMain,
  onDelete,
}) {
  const content = useMemo(() => (
    <Menu createdAt={createdAt} onSetAsMain={onSetAsMain} onDelete={onDelete} isDisabled={isDisabled} />
  ), [createdAt, onSetAsMain, onDelete, isDisabled])

  return (
    <Dropdown
      icon={triggerIcon}
      content={content}
      placement="bottom-start"
      className={className}
      contentClassName="variation-menu__content"
      triggerCloseDropdown={shouldClose}
      setTriggerCloseDropdown={setShouldClose}
      onOpenChange={onOpenChange}
      portalZIndex={PORTAL_Z_INDEX}
    />
  )
}

VariationMenu.propTypes = {
  className: string.isRequired,
  createdAt: string,
  isDisabled: bool,
  shouldClose: bool.isRequired,
  setShouldClose: func.isRequired,
  onOpenChange: func.isRequired,
  onSetAsMain: func.isRequired,
  onDelete: func.isRequired,
}

export default memo(VariationMenu)
